module.exports = __webpack_public_path__ + "static/media/hot_2_badge_fr.8b8aa68d.png";